import { Component, Input, OnInit } from '@angular/core';
import { ControlContainer, FormGroup } from '@angular/forms';
import { TalonarioSituacao } from '@tivic-team/manager-ts/dist/mob';
import { TalonarioAit } from '@tivic-team/manager-ts/dist/mob/entities/ait/talonario-ait.entity';
import { AitTaxiDTOList } from 'app/model/dtos/mob/ait-taxi.dto';
import { AitTaxiSearch } from 'app/services/mob/ait-taxi.search';
import { AitTaxiService } from 'app/services/mob/ait-taxi.service';
import { TalonarioAitSearch } from 'app/services/mob/talonario-ait.search';
import { TalonarioAitService } from 'app/services/mob/talonario-ait.service';
import { ParentFormGroup } from 'app/tools/parent-formgroup';
import { DialogFactory } from 'sol-tools-ts/dist';

@Component({
  selector: 'text-numero-ait-form',
  templateUrl: './text-numero-ait-form.component.html',
  styleUrls: ['./text-numero-ait-form.component.scss'],
  viewProviders: [ParentFormGroup]
})
export class TextNumeroAitFormComponent implements OnInit {

  formGroup: FormGroup;
  
  @Input() validationAutoFocus: boolean = false;
  
  constructor(
    private _aitTaxiService: AitTaxiService,
    private _talonarioAitService: TalonarioAitService,
    private _controlContainer: ControlContainer,
    private _dialogFactory: DialogFactory
  ) { }

  ngOnInit() {
    this.formGroup = this._controlContainer.control as FormGroup;
  }

  fixIdentificador(idAit) {
    return idAit.value = idAit.value.replace(/[^0-9a-z]/gi, '').toUpperCase();
  }

  async onChangeAit($event) {
    let idAit: string = $event.target.value.replace(/[\W_]+/g, '');

    if (idAit) {
      let nrMatches = idAit.match(/\d+/);
      let nrAit = nrMatches ? nrMatches[0] : "";
      if (nrAit == null || nrAit.length == 0) {
        this._dialogFactory.snack('O nº de AIT não é válido.', 'OK', DialogFactory.SNACK_WARNING);
        return;
      }
      let ait: AitTaxiDTOList = await this._aitTaxiService.findAits(new AitTaxiSearch({ nrAit: nrAit}));
      if (ait.total > 0) {
        this._dialogFactory.snack('O nº de AIT já está em uso.', 'OK', DialogFactory.SNACK_WARNING);

        if (this.validationAutoFocus)
          $event.target.focus();
        return;
      }
      
      let talonarios: TalonarioAit[] = await this._talonarioAitService.find(new TalonarioAitSearch({ nrDaSerie: Number.parseInt(nrAit) }));
      if (talonarios.length == 0) {
        this._dialogFactory.snack('N° de AIT não pertence a nenhum talonário registrado.', 'OK', DialogFactory.SNACK_WARNING, { duration: 6000 });
        return;
      }

      if (talonarios.length > 1) {
        this._dialogFactory.snack('N° de AIT pertence a mais de um talonário registrado.', 'OK', DialogFactory.SNACK_WARNING, { duration: 6000 });
        return;
      }

      let talonario: TalonarioAit = talonarios[0];
      if (talonario.stTalao != TalonarioSituacao.ATIVO) {
        this._dialogFactory.snack('N° de AIT não pertence a um talonário ativo.', 'OK', DialogFactory.SNACK_WARNING, { duration: 6000 });
        return;
      }

      if (talonario.cdAgente <= 0 && talonario.dtEntrega == null) {
        this._dialogFactory.snack('N° de AIT não pertence a um talonário distribuído a um agente.', 'OK', DialogFactory.SNACK_WARNING, { duration: 6000 });
        return;
      }

      let nrUltimoAit = parseInt(nrAit);
      
      if(nrUltimoAit > talonario.nrFinal){
        this._dialogFactory.snack('Este talonário não possui mais folhas disponíveis para cadastro.', 'OK', DialogFactory.SNACK_ERROR, { duration: 6000 });
        this.formGroup.value.talonario.tpTalao.patchValue(TalonarioSituacao.CONCLUIDO);
      }
      
      this.formGroup.get('talonario').get('nrUltimoAit').patchValue(nrUltimoAit);
      this.formGroup.get("talonario").patchValue(talonario);
      this.formGroup.get('talonario').get('cdAgente').setValue(talonario.cdAgente);
      this.formGroup.get('agente').get('cdAgente').patchValue(talonario.cdAgente);
    }
  }
}